import { render, staticRenderFns } from "./PlanRowItemFreeTrialCard.vue?vue&type=template&id=54c4f304&"
import script from "./PlanRowItemFreeTrialCard.vue?vue&type=script&lang=js&"
export * from "./PlanRowItemFreeTrialCard.vue?vue&type=script&lang=js&"
import style0 from "./PlanRowItemFreeTrialCard.vue?vue&type=style&index=0&id=54c4f304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports